import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class TransactionEntityImporter  {
    _originalTypeClassName = "zERP.BO.TransactionEntityImporter";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
TransactionEntityImporter.translate = translateService;
}
this.TransactionEntityImporterKey = null;
this._key = this.TransactionEntityImporterKey = 0; 
}

static translate: TranslateService;
_key: any;
private _TransactionEntityImporterKey:any;
get TransactionEntityImporterKey(): any {
    return this._TransactionEntityImporterKey;
  }
set TransactionEntityImporterKey(value: any) {
    this._TransactionEntityImporterKey = value;
    this._key = value;
  }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.TransactionEntityImporterKey == null || $this.TransactionEntityImporterKey == 0;
            }


}